// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".coupon-name-text[data-v-c135b570]{text-overflow:unset;word-break:break-word;white-space:normal}.coupon-name[data-v-c135b570]{max-width:12ch}.item[data-v-c135b570]{padding-top:8px;max-width:100vw}.item__content[data-v-c135b570]{align-self:start;padding-bottom:8px}", ""]);
// Exports
module.exports = exports;
